import React from "react";

export default function Footer() {
  return <footer className="">{/* the footer is epty */}</footer>;
}
